/**
 * List component for transactions, managing list content and implementing event handler
 *
 * Properties:
 *
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useState, useEffect } from "react";
import { Biscuit, IcsBuilder } from "../../../../utils";
import Popup from "../../../components/Popup";
import t from "../../../helpers/t";
import { $, _, Backbone } from "../../../../../vendor";
import {
  locationActions,
  contingentsActions,
  userActions,
  ordersActions,
  useSelector,
} from "inbooma-api";
import { getApiHost } from "../../../../Sync";
import ContingentsListItem from "./ContingentsListItem";
import { rbac } from "../index";
import { getDocHandler, in_array } from "../../../../utils/Helper";
import DropdownMenu from "../../../components/DropdownMenu";
import showNotification from "../../../helpers/showNotification";

const ContingentsList = (props) => {
  const {
    contingents,
    locations,
    resourcetypes,
    dispatch,
    deleteContingent,
    filter,
    setFilter,
    sort,
    setSort,
    _key,
    setKey,
    params,
  } = props;
  const currentUrl = new URL(window.location.href);
  const language = Biscuit.get("user.lang").replace("-", "_");
  const contingentsData = [];
  const [contingentsProducts, setContingentsProducts] = useState(null);
  const [ready, setReady] = useState(false);
  const [popup, setPopup] = useState({
    open: false,
    linkText: "",
    link: "",
  });

  useEffect(() => {
    let cP = {};
    contingents.map((contingent, index) => {
      if (typeof contingent.products !== "undefined" && contingent.products.length > 0) {
        if (typeof cP[contingent.products[0].name] === "undefined") {
          cP[contingent.products[0].name] = [];
        }
        contingent.indexNumber = index;
        contingent.productId = contingent.products[0].id;
        cP[contingent.products[0].name].push(contingent);
      } else {
        let n = t("without product", null, "capital");
        if (typeof cP[n] === "undefined") {
          cP[n] = [];
        }
        contingent.indexNumber = index;
        contingent.productId = null;
        cP[n].push(contingent);
      }
    });
    setContingentsProducts(cP);
  }, [contingents]);

  useEffect(() => {
    if (props._key !== null) {
      let selector = "[key=" + props._key + "]";
      if ($(selector).length >= 1) {
        $("html,body").scrollTop($(selector).offset().top - 10);
      }
    }
  }, []);

  const getLocation = (contingent) => {
    if (typeof contingent.locations === "undefined" || contingent.locations.length === 0) {
      return "";
    }
    if (contingent.locations.length >= 1 && contingent.locations.length < 10) {
      let str = "";
      _.each(contingent.locations, function (location, key) {
        str += key >= 1 ? "-" : "";
        str += location.name;
      });
      return str;
    } else {
      return contingent.locations.length + " " + t("locations");
    }
  };

  const createIcs = (contingent) => {
    const body = {
      contingent_id: contingent.id,
      client_id: contingent.client_id,
    };
    //getDocHandler("/ics/createICS",'POST','ics',contingent.name + '.ics','',contingent.id,body);
    return new IcsBuilder(body, "inbooma_contingent_" + contingent.id);
    /* const icsHelper = new (Backbone.Collection.extend({
            url : '/ics/createICS'
        }));

        icsHelper.create(options, {
            headers: {
                'Accept-Language': language,
                'Authorization': `Bearer ${Biscuit.get('token')}`
            },
            success (model, response) {
                showNotification('success');
            },
            error () {
                alert('Failed to download the calendar file. Please try again later or contact the administrator.');
            }
        });*/
  };

  const getResourcetype = (contingent) => {
    let str = "";
    resourcetypes.map((resourcetype) => {
      if (resourcetype.id === contingent.resourcetype_id) {
        str = resourcetype.name;
      }
    });
    return str;
  };

  const getPricetariff = (contingent) => {
    let id = null;
    if (typeof contingent.products === "undefined" || contingent.products.length === 0) {
      return null;
    }
    contingent.products.map((product) => {
      if (typeof product.pricetariffs !== "undefined" && product.pricetariffs.length !== 0) {
        product.pricetariffs.map((pricetariff) => {
          id = pricetariff.id;
        });
      }
    });
    return id;
  };

  const _printRentalContract = (id, key) => {
    if (typeof id === "object") {
      setCheckoutcontingents(id);
      props.setKey(key);
      props.setCheckout(true);
    } else {
      const ref = getApiHost().slice(0, -4) + "/rental_contract/" + id;
      window.open(ref, "_blank");
    }
  };

  const _printRentalContractDelivery = (id) => {
    const ref = getApiHost().slice(0, -4) + "/ticket/" + id;
    window.open(ref, "_blank");
  };

  const searchParams = currentUrl.searchParams;

  const fillData = () => {
    if (typeof contingents === "undefined") return;

    let contingent;
    let hasResources = false;
    let toggle = false;
    for (var i = 0; i < contingents.length; i++) {
      hasResources = false;
      contingent = contingents[i];
      toggle = false;
      if (
        typeof searchParams.get("item") !== "undefined" &&
        searchParams.get("item") !== null &&
        contingent.id === Number(searchParams.get("item"))
      ) {
        toggle = true;
      }
      hasResources =
        typeof contingent.resources !== "undefined" &&
        contingent.resources !== null &&
        contingent.resources.length > 0;

      let addClasses = "";
      /* if (contingent.status === 'cancelled') {
                addClasses += ' is-cancelled';
            }*/

      if (toggle) {
        addClasses += " toggled";
      }
      let elements;
      elements = [
        {
          type: "text",
          value: "name",
          title: t("name"),
          extraTopClasses: "show-label",
          data: [
            {
              value: "name",
              text: contingent.name,
              extraClasses: "text-small",
              title: t("name", null, "capital"),
            },
          ],
          largeWidth: 3,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "location",
          title: t("location"),
          extraTopClasses: "show-label",
          data: [
            {
              value: "location_id",
              text: getLocation(contingent),
              extraClasses: "text-small",
              title: t("location", null, "capital"),
            },
          ],
          largeWidth: 3,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "description",
          title: t("description"),
          extraTopClasses: "show-label",
          data: [
            {
              value: "description",
              text: contingent.description,
              extraClasses: "text-small",
              title: t("description", null, "capital"),
            },
          ],
          largeWidth: 3,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
        {
          type: "text",
          value: "type",
          title: t("type"),
          extraTopClasses: "show-label",
          data: [
            {
              value: "resourcetype_id",
              text: getResourcetype(contingent),
              extraClasses: "text-small",
              title: t("resourcetype", null, "capital"),
            },
          ],
          largeWidth: 3,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        },
      ];

      /* if(hasCheckIn) {
                     elements.push({
                         type: "bar",
                         value: "state",
                         title: "",
                         data: [{
                             value: "state",
                             text: getState(contingent),
                             extraClasses: getStateClasses(contingent),
                             extra: (contingent.checkins[0].checkout !== null ? 'has-checkout' : ""),
                             title: ""
                         }],
                         mediumWidth: 12,
                         smallWidth: 12,
                         handler: onItemClickedHandler
                     });
                 }*/
      /* if (contingent.status !== 'cancelled') {
                    elements.push({
                        type: "button",
                        value: (typeof contingent.checkins === 'undefined' || contingent.checkins.length === 0) ? t('checkin_contingents', null, 'capital') : t('checkout_contingents', null, 'capital'),
                        title: (typeof contingent.checkins === 'undefined' || contingent.checkins.length === 0) ? t('checkin_contingents', null, 'capital') : t('checkout_contingents', null, 'capital'),
                        extraTopClasses: "inb-contingents__pdf2",
                        data: [{
                            value: contingent.id,
                            icon: "inb-fi-checkin",
                            extraClasses: "inb-round-btn hollow round float-left",
                            ref: "/ContingentsList/" + contingent.id + "/checkin",
                            round: true
                        }],
                        mediumWidth: 1,
                        smallWidth: 1
                    });
                }*/

      if (hasResources) {
        elements.push({
          type: "ResourceAddition",
          value: "resourcs",
          title: "",
          data: [
            {
              value: "resources",
              text: "",
              title: "",
              resources: contingent.resources,
              id: contingent.id,
              app_user_role: Biscuit.get("user.role"),
              contingent: contingent,
              dispatch: dispatch,
              setNKey: setKey,
              _key: "wti-" + i,
              filter: filter,
              setFilter: setFilter,
              sort: sort,
              setSort: setSort,
            },
          ],
          largeWidth: 12,
          mediumWidth: 12,
          smallWidth: 12,
          handler: onItemClickedHandler,
        });
      }

      if (elements !== []) {
        contingentsData[i] = {
          elements: elements,
          addClasses: addClasses,
        };
      }
    }
  };

  const onItemClickedHandler = (value) => {
    console.log("clicked on: ", value);
    if (value.startsWith("acc_invoice_")) {
      // open accumulated invoice
      const id = value.split("acc_invoice_")[1];
    }
    if (value.startsWith("user_")) {
      // fetch user info
      const id = value.split("user_")[1];
      const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

      props.dispatch(
        userActions.getUser({
          token: Biscuit.get("token"),
          id: id,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );

      setPopup({
        ...popup,
        left: el_rect.left + "px",
        top: el_rect.top + "px",
        text: t("user", null, "capital") + ":",
      });
    }
    if (value.startsWith("payment_info_")) {
      const idx = value.split("payment_info_")[1];
      const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

      setPopup({
        ...popup,
        left: el_rect.left + "px",
        top: el_rect.top + "px",
        open: true,
        text: t("payment_error_info") + ": " + props.wallets[idx].message,
        link: "",
        linkText: "",
      });
    }
  };

  const popupCloseHandler = () => {
    setPopup({
      ...popup,
      open: false,
    });
  };
  const getProductId = (contingentProduct) => {
    let id = null;
    if (contingentProduct.length > 0) {
      let contingentTemp = contingentProduct[0];
      if (contingentTemp?.products?.length > 0) {
        id = contingentTemp.products[0].id;
      }
    }
    return id;
  };
  const getContextMenu = (contingent) => {
    let contextMenu = [
      {
        text: t("create_ics", null, "capital"),
        href: "#",
        clickHandler: createIcs,
        getItem: "contingent",
        contingent: contingent,
        iconClass: "fi fi-calendar",
        title: "ics",
      },
    ];
    if (rbac.hasPermission("editContingent")) {
      contextMenu = [
        {
          text: t("edit"),
          href: "/contingents/" + contingent.id + currentUrl.search,
          iconClass: "fi fi-wrench",
          title: "edit",
        },
        {
          text: t("create_ics", null, "capital"),
          href: "#",
          clickHandler: createIcs,
          getItem: "contingent",
          contingent: contingent,
          iconClass: "fi fi-calendar",
          title: "ics",
        },
      ];
      if (rbac.hasPermission("editPrice")) {
        contextMenu.push({
          text: t("edit_${a}", { a: t("prices") }, "capital"),
          href: "/pricetariffs/" + getPricetariff(contingent) + currentUrl.search,
          iconClass: "fi fi-euro",
          title: "pricetariffs",
        });
      }
      contextMenu.push({
        text: t("reservations"),
        href:
          "/reservations/reservationsList?contingent_id=" +
          contingent.id +
          "&contingent_name=" +
          encodeURIComponent(contingent.name) +
          currentUrl.search,
        iconClass: "fi fi-price-tag",
        title: "reservations",
      });
      if (rbac.hasPermission("deleteContingent")) {
        contextMenu.push({
          text: t("delete"),
          href: "#",
          clickHandler: deleteContingent,
          getItem: "contingent",
          contingent: contingent,
          iconClass: "fi fi-trash",
          title: "delete",
        });
      }
    } else {
      contextMenu.push({
        text: t("reservations"),
        href:
          "/reservations/reservationsList?contingent_id=" +
          contingent.id +
          "&contingent_name=" +
          encodeURIComponent(contingent.name) +
          currentUrl.search,
        iconClass: "fi fi-price-tag",
        title: "reservations",
      });
    }

    return contextMenu;
  };
  fillData();
  return (
    <div
      className="inb-c-listing off-canvas-content"
      id="inb-c-main-orders"
      style={{ minHeight: "1150px" }}
    >
      {contingentsProducts !== null &&
        typeof contingents !== "undefined" &&
        contingents.length > 0 &&
        Object.keys(contingentsProducts).map((product, name) => {
          return (
            <>
              <fieldset className="fieldBox" style={{ width: "98%", border: "none" }}>
                <label
                  title={t("edit_${a}", { a: t("product", null, "capital") })}
                  className="inb-form__controlLabel"
                  style={{ paddingLeft: "1.5%" }}
                >
                  {product}{" "}
                  {getProductId(contingentsProducts[product]) !== null && (
                    <a
                      href={
                        "/products/" +
                        getProductId(contingentsProducts[product]) +
                        currentUrl.search
                      }
                    >
                      <i className="fi fi-pencil" />
                    </a>
                  )}
                </label>
                {/* {getProductId(contingentsProducts[product]) !== null &&
                        <DropdownMenu
                        menu={[
                            {
                                text: t('edit'),
                                href: "/products/" + getProductId(contingentsProducts[product]) + currentUrl.search,
                                iconClass: "fi fi-wrench",
                                title: "edit"
                            }]}
                    />}*/}
                {contingentsProducts[product].map((contingent) => {
                  let index = contingent.indexNumber;
                  let contingentMenu = getContextMenu(contingent);

                  return (
                    <>
                      {typeof contingentsData[index] !== "undefined" &&
                        typeof contingentsData[index].elements !== "undefined" && (
                          <ContingentsListItem
                            contingent={contingent}
                            locations={locations}
                            refLink={"contingents"}
                            dispatch={dispatch}
                            length={
                              typeof contingents.resources !== "undefined"
                                ? contingents.resources.length
                                : 1
                            }
                            key={"wti-" + index}
                            _key={"wti-" + index}
                            listStyle="tight"
                            id={"row-" + contingent.id}
                            overwriteClasses={
                              "inb-c-item inb-c-item--order inb-c-item-contingents row" +
                              contingentsData[index].addClasses
                            }
                            elements={contingentsData[index].elements}
                            setFilter={setFilter}
                            filter={filter}
                            setNKey={setKey}
                            sort={sort}
                            setSort={setSort}
                            menu={contingentMenu}
                          />
                        )}
                    </>
                  );
                })}
              </fieldset>
            </>
          );
        })}

      {popup.open === true && (
        <Popup
          left={popup.left}
          top={popup.top}
          linkText={popup.linkText}
          text={popup.text}
          link={popup.link}
          onCloseHandler={popupCloseHandler}
        />
      )}
    </div>
  );
};
export default ContingentsList;
